import { observer } from 'mobx-react';

import { RightMenu } from '@components/RightMenu';
import { store } from '@store';

export const RightMenuWrapper = observer(() => {
    const {
        children,
        isShowing,
        fullScreenHeight,
        stickyButtonsLayout,
        isCloseButtonHidden,
        customWidth,
        withoutMask,
        closeOnEscOnly,
        right,
        zIndex,
        onClickOutside,
    } = store.app.rightMenu;

    return (
        <RightMenu
            right={right}
            withoutMask={withoutMask}
            closeOnEscOnly={closeOnEscOnly}
            fullScreenHeight={fullScreenHeight}
            stickyButtonsLayout={stickyButtonsLayout}
            isShowing={isShowing}
            isCloseButtonHidden={isCloseButtonHidden}
            customWidth={customWidth}
            onClickOutside={onClickOutside}
            closeByEsc={onClickOutside}
            zIndex={zIndex ?? 250}
        >
            {children}
        </RightMenu>
    );
});
